module.exports = __webpack_public_path__ + "img/pop-品牌旗舰店入驻@2x.d8f153c0.jpg";